/* styles */
import useStyles from './useStyles'
import { Checkbox, Typography } from '@mui/material'
import { traducNameTemporal } from '../../../../utils/traducTypes'
import ModalMenuItem from '../../ModalMenu/ModalMenu'

/* redux */

function TableItem ({ item, setLoading }) {
  const classes = useStyles()

   return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemCheck}>
          <Checkbox />
        </td>
        <td className={classes.itemIcon}>
          {item.isActive
            ? ( 
            <Typography className={classes.itemStatusActive}>Activo</Typography>
        
              )
            : ( 
            <Typography className={classes.itemStatusInactive}>No Activo</Typography>
           
              )}
        </td>
        <td className={classes.itemName}>{item.organizationName || '- -'}</td>
        <td className={classes.itemLegalName}>
          {item.organizationLegalName || '- -'}
        </td>
        <td className={classes.itemCuit}>{item.organizationCuit || '- -'}</td>
        <td className={classes.itemType}>
          {traducNameTemporal(item.organizationType?.organizationTypeCode) ||
            '- -'}
        </td>
        <td className={classes.itemKebab}>
          <ModalMenuItem item={item} setLoading={setLoading} />
        </td>
      </tr>
    </>
  )
}

export default TableItem
